const getChipDefaultSize = ()=>'medium';

export { getChipDefaultSize as g };
